import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isCoach = user?.role === "tecnico";

  const links = isCoach
    ? [
        { to: "/dashboard", label: "Dashboard" },
        { to: "/atletas", label: "Atletas" },
        { to: "/treino", label: "Registrar Treino" },
        { to: "/relatorios", label: "Relatórios" },
        { to: "/convites", label: "Convites" },
      ]
    : [
        { to: "/passaporte", label: "Meu Passaporte" },
        { to: "/treino", label: "Registrar Arremessos" },
      ];

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <header className="sticky top-0 z-40 glass border-b border-zinc-800" data-testid="app-header">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <button onClick={() => navigate(isCoach ? "/dashboard" : "/passaporte")} className="flex items-center gap-3" data-testid="logo-home">
              <div className="w-9 h-9 rounded-sm bg-[#FF3B30] flex items-center justify-center font-display font-black text-white text-lg">PA</div>
              <div className="hidden sm:block">
                <div className="font-display font-black text-lg uppercase tracking-tight leading-none">Passaporte do Atleta</div>
                <div className="text-[10px] text-zinc-500 uppercase tracking-[0.2em]">Análise de Arremessos</div>
              </div>
            </button>
            <nav className="hidden md:flex items-center gap-1">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`nav-${l.to.slice(1)}`}
                  className={({ isActive }) =>
                    `px-4 py-2 rounded-sm text-sm font-bold uppercase tracking-wide transition-colors ${
                      isActive ? "bg-[#FF3B30] text-white" : "text-zinc-400 hover:text-white hover:bg-zinc-900"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex items-center gap-3">
              {user?.picture ? (
                <img src={user.picture} alt="" className="w-8 h-8 rounded-full" referrerPolicy="no-referrer" />
              ) : (
                <div className="w-8 h-8 rounded-full bg-zinc-800 flex items-center justify-center text-xs font-bold">
                  {user?.name?.[0]?.toUpperCase() || "?"}
                </div>
              )}
              <div className="text-right leading-tight">
                <div className="text-sm font-bold">{user?.name}</div>
                <div className="text-[10px] text-zinc-500 uppercase tracking-widest">
                  {isCoach ? "Técnico" : "Atleta"}
                </div>
              </div>
            </div>
            <Button
              onClick={logout}
              data-testid="logout-btn"
              variant="outline"
              className="bg-transparent border-zinc-700 hover:border-zinc-500 hover:bg-zinc-900 text-white text-xs uppercase tracking-wide font-bold"
            >
              Sair
            </Button>
          </div>
        </div>
        {/* Mobile nav */}
        <nav className="md:hidden flex items-center gap-1 px-4 pb-3 overflow-x-auto">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `whitespace-nowrap px-3 py-1.5 rounded-sm text-xs font-bold uppercase tracking-wide ${
                  isActive ? "bg-[#FF3B30] text-white" : "text-zinc-400 bg-zinc-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="max-w-7xl mx-auto px-6 md:px-8 py-8 fade-up">{children}</main>
    </div>
  );
}
